import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=5bfd7ea9&scoped=true"
import script from "./recycle.vue?vue&type=script&lang=js"
export * from "./recycle.vue?vue&type=script&lang=js"
import style0 from "./recycle.vue?vue&type=style&index=0&id=5bfd7ea9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd7ea9",
  null
  
)

export default component.exports